/**
 * What colleagues say to each other, not to you: a line and the answer to it.
 *
 * Over their heads, in the line under their name, like anything else anybody
 * says (`sim/crewTalk.js`). Nothing reads it but the screen. Short, because
 * nobody has time, and in the house's voice: whole words, no contractions,
 * no em dash, never a name you could check.
 *
 * `break` is said sat down in the break room; a department's own is said
 * between two of that department on the floor; `any` between anybody.
 */
export const CREW_TALK = Object.freeze({
  break: [
    ['Is that the same sandwich as yesterday?', 'Different sandwich. Same bread.'],
    ['Thirty minutes. I am taking all thirty.', 'Take thirty-one. Nobody is counting.'],
    ['Who took my yoghurt?', 'Ask whoever is hungriest.'],
    ['My feet have stopped talking to me.', 'Mine went home an hour ago.'],
    ['Did you see the board?', 'I saw it. I am not looking again.'],
    ['Coffee is cold again.', 'Coffee is always cold. That is the coffee.'],
    ['Does the machine take cards yet?', 'It takes them. It does not give anything back.'],
    ['Is it still raining out there?', 'It is the desert. It is never raining.'],
    ['How many rooms have you got?', 'Two. One of them is the gala.'],
    ['Wake me up at quarter past.', 'I will not.'],
  ],
  banquets: [
    ['Who has the chair cart?', 'Ballroom. It is always the ballroom.'],
    ['Captain is looking for you.', 'Captain is always looking for somebody.'],
    ['Is the linen in yet?', 'Half of it. The ivory half.'],
    ['Six rounds by four?', 'Six by four. Dance floor clear.'],
    ['Did they change the count again?', 'Twice. Mother of the bride.'],
    ['Who is on the strike tonight?', 'Not me. I did last night.'],
  ],
  kitchen: [
    ['Hands on the pass.', 'Heard.'],
    ['Behind you, hot.', 'Heard, behind.'],
    ['Eighty covers at seven.', 'Then we plate at quarter to.'],
    ['Who touched my knife?', 'Nobody touched your knife.'],
  ],
  housekeeping: [
    ['Third floor wants towels again.', 'Third floor can wait for towels.'],
    ['Linen count is off.', 'Linen count is always off on a Friday.'],
    ['Did you do 412?', 'Twice. They keep coming back.'],
  ],
  valet: [
    ['Silver one is blocking the drive.', 'Silver one is the owner. Leave it.'],
    ['Keys for twelve?', 'Board, top hook.'],
    ['Shuttle is late again.', 'Shuttle is always late. Wave at it.'],
  ],
  frontdesk: [
    ['Late check-out on 412.', 'Again? Fine. Two o clock.'],
    ['Is the left lift working?', 'It is. Do not tell anybody.'],
    ['Somebody wants a view.', 'Give them the pool. Call it a view.'],
  ],
  engineering: [
    ['Walk-in is warm again.', 'Walk-in is always warm. I will look.'],
    ['Who moved my ladder?', 'Nobody. It walked.'],
    ['Ballroom air wall is sticking.', 'It sticks if you push it. Do not push it.'],
  ],
  management: [
    ['Numbers are in.', 'Do I want to see them?'],
    ['Owners are asking questions.', 'Owners can keep asking.'],
  ],
  any: [
    ['You on tomorrow?', 'Double. Do not ask.'],
    ['Did they post the schedule?', 'Posted it, then changed it.'],
    ['Long day.', 'They are all long days.'],
    ['Have you eaten?', 'Not since Tuesday.'],
  ],
});

export default CREW_TALK;
